var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.447 5h7.106a2 2 0 0 1 1.908 1.401L18.277 9H5.723l.816-2.599A2 2 0 0 1 8.447 5Zm-5.15 5.05L4.63 5.804A4 4 0 0 1 8.447 3h7.106a4 4 0 0 1 3.817 2.803l1.332 4.248A3.99 3.99 0 0 1 22 13v8h-2v-3H4v3H2v-8c0-1.167.5-2.218 1.298-2.95ZM6 11a2 2 0 0 0-2 2v3h16v-3a2 2 0 0 0-2-2H6Zm3 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  })));
};
export default SvgCar;